import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InspectJobApplicationState } from "./types";
import { IJobApplication } from "@/shared/api/employment";

const initialState: InspectJobApplicationState = {
    isInspectJobApplicationModalOpen: false,
    isApproveJobApplicationModalOpen: false,
    isRejectJobApplicationModalOpen: false,

    currentApplication: {
        id: "",
        user_id: "",
        created_at: "",
        status: "pending",
        user: {
            id: "",
            username: ""
        },
        job_opening: {
            id: "",
            name: "",
            template: []
        },
        values: {}
    },

    onApprove: null,
    onReject: null
}

interface OpenRejectApplicationModal {
    data: IJobApplication
    onSuccess?: () => void
}

interface OpenApproveApplicationModal {
    data: IJobApplication
    onSuccess?: () => void
}

const updateJobApplicationSlice = createSlice({
    name: 'updateJobApplication',
    initialState,
    reducers: {
        openInspectApplicationModal: (state, action: PayloadAction<IJobApplication>) => {
            state.isInspectJobApplicationModalOpen = true
            state.currentApplication = action.payload
        },
        closeInspectApplicationModal: (state) => {
            state.isInspectJobApplicationModalOpen = false
        },
        openRejectApplicationModal: (state, action: PayloadAction<OpenRejectApplicationModal>) => {
            state.isRejectJobApplicationModalOpen = true
            state.currentApplication = action.payload.data
            state.onReject = action.payload.onSuccess
        },
        closeRejectApplicationModal: (state) => {
            state.isRejectJobApplicationModalOpen = false
        },
        openApproveApplicationModal: (state, action: PayloadAction<OpenApproveApplicationModal>) => {
            state.isApproveJobApplicationModalOpen = true
            state.currentApplication = action.payload.data
            state.onApprove = action.payload.onSuccess
        },
        closeApproveApplicationModal: (state) => {
            state.isApproveJobApplicationModalOpen = false
        },
    }
})

export default updateJobApplicationSlice.reducer
export const { 
    openApproveApplicationModal,
    openInspectApplicationModal,
    openRejectApplicationModal,
    closeApproveApplicationModal,
    closeInspectApplicationModal,
    closeRejectApplicationModal
} = updateJobApplicationSlice.actions